<template>
  <input
    type="file"
    class="w-full file:rounded file:border-grey-30 file:bg-white file:px-4 file:py-2 file:text-sm hover:file:cursor-pointer hover:file:bg-grey-20"
    :class="classes"
    :name="name"
    :readonly="readonly"
    :placeholder="placeholder"
    :disabled="disabled"
    :id="`inputFile-${uuid}`"
    :aria-errormessage="`inputFile-error-${uuid}`"
    @change="onChange"
  />
  <span
    class="text-sm text-red-600"
    v-if="error"
    :id="`inputFile-error-${uuid}`"
  >
    {{ errorMessage }}
  </span>
</template>

<script>
import input from 'Mixins/input';
import uuid from 'Mixins/uuid';

export default {
  name: 'InputFile',
  mixins: [input, uuid],
  computed: {
    classes() {
      return {
        'file:bg-red-200': this.error,
      };
    },
  },
  methods: {
    onChange(event) {
      this.$emit('change', event);
    },
  },
};
</script>
